import { Anchor, Card } from '@zenid/web';
import { genericError } from '../../../../styled-system/recipes';

export function IntegrationGuarantorEmailConflict() {
  const { contentsLayout, contentsInnerLayout, iconLayout, icon, title, messageLayout, message, actionsLayout } =
    genericError();
  return (
    <Card className={contentsLayout}>
      <div className={contentsInnerLayout}>
        <div className={iconLayout}>
          <img
            src={`${import.meta.env.VITE_ASSETS_URL}/assets/images/seagull_meal.png`}
            className={icon}
            alt="エラーページのアイコン"
          />
        </div>
        <div className={messageLayout}>
          <h1 className={title}>エラー</h1>
          <p className={message}>保護者のメールアドレスとして登録されているものはサブメールアドレスに使用できません</p>
        </div>
        <div className={actionsLayout}>
          <Anchor variant="button" href="/home" color="primary" size="l" width={200}>
            ZEN IDに戻る
          </Anchor>
        </div>
      </div>
    </Card>
  );
}
